<template>
    <!--  -->
     <div class="modal fade" id="makeRequestModal" tabindex="-1" aria-labelledby="createItemModalLabel" aria-hidden="true">
         <div class="modal-dialog modal-xl">
           <div class="modal-content">
             <div class="modal-header">
               <h5 class="modal-title" id="createItemModalLabel">Make Stock Request</h5>
               <button type="button"  data-bs-dismiss="modal" aria-label="Close">X</button>
             </div>
             <div class="modal-body">
                 <!-- <form>
                     <div class="form-group">
                         <label for="exampleInputEmail1">Store Name</label>
                         <input name="store_name" v-on:keyup="handleKeyUp" type="text" class="form-control" placeholder="Enter store name">
                         <small id="emailHelp" class="form-text text-muted">This is creates a new item location</small>
                     </div>
                     <button @click="submitHandler" class="btn btn-primary righter">Submit</button>
                 </form> -->

                 <form  @submit.prevent="handleSubmit">
                    <div class="row">
                        <table>
                                <tr>
                                    <th>From Store</th>
                                    <th>Destination Store</th>
                                </tr>
                                <tr >
                                    <td width="40%">

                                        <select  @change="changeStore" name="origin_store_id" class="form-control">
                                            <option value="0">Select Store...</option>
                                            <option v-for="store in store_list" :key="store.id" :value="store.id" >
                                                {{ store.store_name }}
                                            </option>
                                            
                                        </select>
                                       <span v-if="origin_store_id==0" class="danger">This field is required</span>
                                    </td>
                                    <td width="40%">
                                        <select  @change="changeStore" name="destination_store_id" class="form-control" disabled>
                                            <option value="0">Select Store...</option>
                                            <option v-for="store in store_list" :key="store.id" :value="store.id" :selected="store.id == this.$route.params.storeLocation">
                                                {{ store.store_name }}
                                                </option>
                                        </select>
                                        
                                    </td>
                                
                                    <td width="20%">
                                        <button  v-on:click="add_column()"   class="mb-4 fs-5 float-end mycustom-success-button" type="button">+ Add</button>
                                        <!-- v-on:click="add_column" -->
                                    </td>
                                </tr>
                        </table>
                    </div>
                  
                  <hr/>
                    <div class="row">
                       
                        <!-- <div class="form-group col-md-6">
                            <label for="item_category_id">Item Category</label>
                            <select id="item_category_id" v-on:change="handleKeyUp" class="form-control" name="item_category_id" required>
                                <option value="">Choose...</option>
                                <option v-for="category in all_cats" :key="category.id" :value="category.id">{{ category.category_name }}</option>
                            </select>
                        </div> -->

                      
                        <table>
                            <tr>
                                <!-- <th>Item Class</th> -->
                                <th>Item Name</th>
                                <th>Quantity</th>
                                <th>Action</th>
                            </tr>

                            <tr v-for="row in rows" :key="row.id">
                                <!-- <td width="30%">
                                    <select id="item_class_id" v-on:change="onchangeHandler(row.id)" class="form-control" name="class_id">
                                        <option value="">Choose...</option>
                                        <option v-for="clas in all_clas" :key="clas.id" :value="clas.id">{{ clas.class_name }}</option>
                                    </select>
                                    <span>.</span>
                                </td> -->
                                <td width="60%">
                                    <ItemInput @itemoption-check="takeItem" :Rowid="row.id" :Store_id="this.origin_store_id"/>
                                    <!-- <input type="text" autocomplete="off" name="item_name" v-on:blur="blurHandler(row.id)"  v-on:keyup="onchangeHandler(row.id)" class="form-control" placeholder="item name">
                                    <div class="suggestion_capsule" :id="`itemSuggestions`+row.id" :ref="`itemSuggestions`+row.id"></div> -->
                                    <span>.</span>
                                </td>
                                <td width="30%">
                                    <input type="number" name="quantity" v-on:keyup="onchangeHandler(row.id)" class="form-control"  placeholder="Quantity">
                                    <span class="fs-10">Available Quantity : <span :ref="`c_qty`+row.id"></span> </span>
                                </td>
                                <td width="10%">
                                    <button v-on:click="remove_column( row.id )"   class="mb-4 fs-6 mycustom-danger-button" type="button">--</button>
                                    <!-- v-on:click="add_column" -->
                                </td>
                            </tr>
                        </table>
                       
                        
                    </div>

                   
                    <br/>
                    
                    <button v-if="show_submit == true" @click="submitHandler" class="btn btn-primary righter">Submit</button>
                    <!-- <div v-if="!show_submit" class="righter">....</div> -->
                 </form>
             </div>
             
           </div>
         </div>
       </div>
          <!--  -->
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import ItemInput from '../components/iteminput.vue'

export default {
    name:"requestmodal",
    data() {
    return {
        rows:[
            {class_id:"", class_name:"",  item_name:"", item_id:"", quantity:"", available_quantity:"", id:1, c_quantity:""}
            ],
        store_list:[],
        store_name:"",
        store_id:"",
        origin_store_id:0,
        destination_store_id:this.$route.params.storeLocation,
        // danger: 'red',
         show_submit: true,
    };
},

components: {
    ItemInput,
  },

//   computed: {
//     storeInputStyle() {
//       return this.origin_store_id==0 ? this.danger : this.normal;
//     },
//   },

methods:{
    async submitHandler(){
       this.show_submit = false;
       
       try {
        const url = 'inventory/storeInventoryMovement'; 
        const body = {data: this.rows, initiating_store: this.$route.params.storeLocation,  origin_store_id:this.origin_store_id, destination_store_id:this.destination_store_id};

        var res = await generalApiRequest(url, 'POST', body, 1);

        if (res.status == 200) {
           // console.log(res.status);
           window.location.reload();
        }else{
            this.show_submit = true;
        }

      } catch (error) {
        this.show_submit = true;
         console.error('Error fetching data:', error);
      }

    },
  
    async get_stores_list(){
      try {
        const url = 'inventory/getCompanyItemStores_for_input'; 
        const body = {};

        const store_list = await generalApiRequest(url, 'GET', body, 1);
        this.store_list = store_list;
        
        store_list.forEach(element => {
            if (element.id == this.$route.params.storeLocation) {
                this.store_name = element.store_name;
                this.store_id = element.id; 
                
                // console.log(element);
            }
            
        });

      } catch (error) {
         console.error('Error fetching data:', error);
      }

    },

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    },

    add_column(){
        var gen_id = this.getRandomInt(2, 9000);
       // console.log(this.rows);
        var newRow = {class_id:"", class_name:"",  item_name:"", item_id:"", quantity:"", available_quantity:"", id:gen_id, c_quantity:""};
        this.rows = [...this.rows, newRow];
    },

    remove_column(identifier){
        for (let i = 0; i < this.rows.length; i++) {
            if (this.rows[i].id === identifier) {
            this.rows.splice(i, 1);
            return; // Exit the loop after finding and removing
            }
        };
        console.warn(`Row with ID "${identifier}" not found.`);
    },
  
    takeItem(content, row){
        console.log(content);
        console.log(row);

        var state_object = this.rows;
       // console.log(state_object);
        for (let i = 0; i < state_object.length; i++) {
            if (state_object[i].id === row) {
               
                state_object[i].item_id = content.id;
                this.rows = state_object;
            }
        }

        /////

        const myElement = this.$refs["c_qty"+row]; 
        const newContent = document.createElement('span');
        newContent.innerHTML =  '<span>'+content.c_quantity+'</span>';
        if (myElement.firstChild) {
          myElement.replaceChild(newContent, myElement.firstChild);
         }else{
          myElement.appendChild(newContent);
         }

    },
    async get_all_cats(){
        try {
            const url = 'inventory/getCompanyItemCategory'; 
            const body = {plain : "1"};
            const cats = await generalApiRequest(url, 'GET', body, 1);
            //console.log(cats);
            this.all_cats = cats;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    },

    async get_all_class(){
        try {
            const url = 'inventory/getCompanyItemClass'; 
            const body = {plain : "1"};
            const clas = await generalApiRequest(url, 'GET', body, 1);
           // console.log(clas);
            this.all_clas = clas
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    },

    changeStore(e){
        console.log(e.target.name);
        this[e.target.name]=e.target.value;

    },

    async onchangeHandler(row){

        var state_object = this.rows;

        for (let i = 0; i < state_object.length; i++) {
            if (state_object[i].id === row) {
               
                state_object[i][event.target.name] = event.target.value;
                this.rows = state_object;
                 
            }
        };
        
    },
    handleKeyUp2(){
        console.log("firing this");
        //this[e.target.name] = e.target.value;
       // console.log(id);
        // console.log(e.target.name);
    },
    optionclick(){
        console.log("clicked");
    },

    blurHandler(row){
       
        const myElement = this.$refs["itemSuggestions"+row]; 
          if (myElement) {
              const newContent = document.createElement('div');
               newContent.innerHTML = ``;

               if (myElement.firstChild) {
                  myElement.replaceChild(newContent, myElement.firstChild);
               }else{
                 myElement.appendChild(newContent);
                }
          } 

    },

},

mounted() {
    this.get_all_class();
    this.get_all_cats();
    this.get_stores_list();
  },

}
</script>

<style>
.suggestion_capsule{
    border: 1px solid grey;
    border-radius: 0.2em;
    z-index: 7;
    position: absolute;
    background-color: azure;
    max-height: 50vh;
    overflow-x: auto;
    /* padding-right: 1em; */
}
.spacer{
    padding-right: 1em;
    padding-left: 1em;
}
.min_dull{
    color: grey;
    font-size: 0.8em;
}
.borderit{
    border-bottom: 1px solid rgb(184, 212, 216) !important;
    /* background-color: brown; */
}

.borderit:hover {
  background-color: beige; /* Color on hover */
}
.danger {
    color: red;
}
.normal{
    border-color: green;
}
</style>